import { useSelector, useDispatch } from "react-redux";
import {
  isValidName,
  isValidEmail,
  isValidPhoneNumber,
} from "../../../utils/index";
import {
  setNewUserDetails,
  setNewUserError,
  postNewUser,
  setNewUserOpen,
  checkUser,
  setAdminCheck,
} from "../../../redux/slices/sellerDataUserListSlice";
import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
} from "@mui/material";

import {
  UpdateTextField,
  UpdateSelectBox,
  UpdateSelectTag,
  UpdateSelect,
  ErrorMessageHelper,
  AddUserContainer,
  AddUserHeader,
  AddUserArrow,
  AddDetailsContainer,
  FormControlForSelect,
  SelectInputLabel,
  AddDetailsBox,
  AddButtonBox,
  AddButton,
} from "./styles/index";

export const UserListAdd = (props) => {
  const dispatch = useDispatch();

  const { state } = useSelector((state) => ({
    state: state.sellerDataUserList,
  }));

  const userDetails = state.newUser;
  const error = state.newUserError;

  const apiData = (data) => {
    return {
      user_first_name: data.firstName,
      user_last_name: data.lastName,
      user_email: data.email,
      user_phone: data.phoneNumber,
      role_id: data.role,
      sub_role_type_id: data.subRole,
      additional_access_id: [...data.additionalAccess],
      preferred_language_type: data.language,
    };
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    disablePortal: true,
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        // width: 150,
      },
    },
  };

  const handleRole = (selectedRole) => {
    const selected = state.roles?.find((role) => role.role_id === selectedRole);
    return selected?.role_en ? selected.role_en : null;
  };

  const handleSubRole = (selectedSubRole) => {
    const selected = state.subRoles?.find(
      (subRole) => subRole.sub_role_type_id === selectedSubRole
    );
    return selected?.sub_role_type_en ? selected.sub_role_type_en : null;
  };

  const handleAdditionAccess = (selectedItems) => {
    let items = "";
    selectedItems?.map((selectedItem, i) => {
      const selected = state.userAccess?.find(
        (item) => item.additional_access_id === selectedItem
      );

      if (i !== 0) items = items + "; " + selected.additional_access_en;
      else items = items + selected.additional_access_en;

      return null;
    });
    return items.length ? items : null;
  };

  const handleLanguage = (selectedLanguage) => {
    const selected = state.languages?.find(
      (language) => language.preferred_language_type === selectedLanguage
    );
    return selected?.preferred_language_description
      ? selected.preferred_language_description
      : null;
  };

  const handleFormChange = (e) => {
    if (e.target.name === "firstName") {
      const checkValidation = isValidName(e.target.value);

      if (!checkValidation.valid)
        dispatch(
          setNewUserError({
            ...error,
            firstName: checkValidation.error,
          })
        );
      else
        dispatch(
          setNewUserError({
            ...error,
            firstName: "",
          })
        );

      dispatch(
        setNewUserDetails({
          ...userDetails,
          firstName: e.target.value,
        })
      );
    } else if (e.target.name === "email") {
      const checkValidation = isValidEmail(e.target.value);

      if (!checkValidation.valid)
        dispatch(
          setNewUserError({
            ...error,
            email: checkValidation.error,
          })
        );
      else
        dispatch(
          setNewUserError({
            ...error,
            email: "",
          })
        );

      dispatch(
        setNewUserDetails({
          ...userDetails,
          email: e.target.value,
        })
      );
    } else if (e.target.name === "lastName") {
      const checkValidation = isValidName(e.target.value);

      if (!checkValidation.valid)
        dispatch(
          setNewUserError({
            ...error,
            lastName: checkValidation.error,
          })
        );
      else
        dispatch(
          setNewUserError({
            ...error,
            lastName: "",
          })
        );

      dispatch(
        setNewUserDetails({
          ...userDetails,
          lastName: e.target.value,
        })
      );
    } else if (e.target.name === "phoneNumber") {
      const checkValidation = isValidPhoneNumber(e.target.value);

      if (!checkValidation.valid)
        dispatch(
          setNewUserError({
            ...error,
            phoneNumber: checkValidation.error,
          })
        );
      else
        dispatch(
          setNewUserError({
            ...error,
            phoneNumber: "",
          })
        );

      dispatch(
        setNewUserDetails({
          ...userDetails,
          phoneNumber: e.target.value,
        })
      );
    } else if (e.target.name === "role") {
      if (e.target.value.trim().length && e.target.value === "USR001")
        dispatch(
          checkUser({
            flag: "AC",
            seller_id: props.sellerId,
            user_email: "",
            type: "add",
            data: e.target.value,
          })
        );
      else {
        dispatch(setAdminCheck(false));
        dispatch(
          setNewUserDetails({
            ...userDetails,
            role: e.target.value,
          })
        );
      }
    } else if (e.target.name === "subRole") {
      dispatch(
        setNewUserDetails({
          ...userDetails,
          subRole: e.target.value,
        })
      );
    } else if (e.target.name === "additionalAccess") {
      dispatch(
        setNewUserDetails({
          ...userDetails,
          additionalAccess: [...e.target.value],
        })
      );
    } else if (e.target.name === "language") {
      dispatch(
        setNewUserDetails({
          ...userDetails,
          language: e.target.value,
        })
      );
    }
  };

  const handleEmailExists = (e) => {
    if (!error.email.trim().length)
      dispatch(
        checkUser({
          flag: "EC",
          seller_id: props.sellerId,
          user_email: e.target.value,
          type: "add",
        })
      );
  };

  const handleAddAdmin = (e) => {};

  const handleAddSubmit = (e) => {
    if (state.isNewUserFormDataChange) {
      const userData = apiData(userDetails);
      dispatch(postNewUser({ userData: userData, seller_id: props.sellerId }));
    }
  };

  const handleNewUserOpen = () => {
    dispatch(setNewUserOpen(!state.newUserOpen));
  };

  return (
    <Box>
      <AddUserContainer
        expanded={state.newUserOpen}
        onChange={handleNewUserOpen}
      >
        <AddUserHeader expandIcon={<AddUserArrow />}>
          Add a New User
        </AddUserHeader>
        <AddDetailsContainer>
          <AddDetailsBox container xs={12} lg={10}>
            <Grid item xs={12} md={5.5}>
              <UpdateTextField
                id="standard-basic"
                label="First Name *"
                variant="standard"
                name="firstName"
                error={error.firstName?.trim() ? true : false}
                helperText={
                  <ErrorMessageHelper>{error.firstName}</ErrorMessageHelper>
                }
                onChange={handleFormChange}
                value={userDetails.firstName}
              ></UpdateTextField>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateTextField
                id="standard-basic"
                label="Last Name *"
                variant="standard"
                name="lastName"
                error={error.lastName?.trim() ? true : false}
                helperText={
                  <ErrorMessageHelper>{error.lastName}</ErrorMessageHelper>
                }
                onChange={handleFormChange}
                value={userDetails.lastName}
              ></UpdateTextField>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateTextField
                id="standard-basic"
                label="Email *"
                variant="standard"
                name="email"
                error={error.email?.trim() ? true : false}
                helperText={
                  <ErrorMessageHelper>{error.email}</ErrorMessageHelper>
                }
                onChange={handleFormChange}
                onBlur={handleEmailExists}
                value={userDetails.email}
              ></UpdateTextField>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateTextField
                id="standard-basic"
                label="Phone Number"
                variant="standard"
                name="phoneNumber"
                onChange={handleFormChange}
                error={error.phoneNumber?.trim() ? true : false}
                helperText={
                  <ErrorMessageHelper>{error.phoneNumber}</ErrorMessageHelper>
                }
                value={userDetails.phoneNumber}
              ></UpdateTextField>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateSelectBox sx={{ marginBottom: "15px" }}>
                <FormControlForSelect>
                  <SelectInputLabel
                    length={userDetails.role.length}
                    sx={{
                      color: error.role.length !== 0 ? "red" : "#4A4F55",
                    }}
                  >
                    Role *
                  </SelectInputLabel>
                  <UpdateSelect
                    variant="standard"
                    name="role"
                    value={userDetails.role}
                    width="100%"
                    onChange={handleFormChange}
                    onBlur={handleAddAdmin}
                    renderValue={handleRole}
                    error={error.role?.trim() ? true : false}
                    helperText={
                      <ErrorMessageHelper>{error.role}</ErrorMessageHelper>
                    }
                    MenuProps={MenuProps}
                  >
                    {state.roles?.map((role) => (
                      <MenuItem key={role.role_id} value={role.role_id}>
                        <Checkbox
                          checked={
                            userDetails.role === role.role_id ? true : false
                          }
                        />
                        <ListItemText primary={role.role_en} />
                      </MenuItem>
                    ))}
                  </UpdateSelect>
                  <FormHelperText
                    sx={{
                      position: "absolute",
                      left: -14,
                      bottom: -20,
                      fontSize: props.isMobile ? "0.5rem" : "0.55rem",
                      color: "red",
                    }}
                  >
                    {error.role}
                  </FormHelperText>
                </FormControlForSelect>
              </UpdateSelectBox>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateSelectBox sx={{ marginBottom: "15px" }}>
                <FormControlForSelect>
                  <SelectInputLabel
                    length={userDetails.subRole.length}
                    sx={{
                      color: error.subRole.length !== 0 ? "red" : "#4A4F55",
                    }}
                  >
                    Type *
                  </SelectInputLabel>
                  <UpdateSelect
                    variant="standard"
                    name="subRole"
                    value={userDetails.subRole}
                    width="100%"
                    onChange={handleFormChange}
                    renderValue={handleSubRole}
                    error={error.subRole?.trim() ? true : false}
                    helperText={
                      <ErrorMessageHelper>{error.subRole}</ErrorMessageHelper>
                    }
                    MenuProps={MenuProps}
                  >
                    {state.subRoles?.map((subRole) => (
                      <MenuItem
                        key={subRole.sub_role_type_id}
                        value={subRole.sub_role_type_id}
                      >
                        <Checkbox
                          checked={
                            userDetails.subRole === subRole.sub_role_type_id
                              ? true
                              : false
                          }
                        />
                        <ListItemText primary={subRole.sub_role_type_en} />
                      </MenuItem>
                    ))}
                  </UpdateSelect>
                  <FormHelperText
                    sx={{
                      position: "absolute",
                      left: -14,
                      bottom: -20,
                      fontSize: props.isMobile ? "0.5rem" : "0.55rem",
                      color: "red",
                    }}
                  >
                    {error.subRole}
                  </FormHelperText>
                </FormControlForSelect>
              </UpdateSelectBox>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateSelectBox>
                <FormControlForSelect>
                  <SelectInputLabel length={userDetails.role.length}>
                    Additional Access
                  </SelectInputLabel>
                  <UpdateSelect
                    multiple
                    variant="standard"
                    name="additionalAccess"
                    value={userDetails.additionalAccess}
                    onChange={handleFormChange}
                    renderValue={handleAdditionAccess}
                    MenuProps={MenuProps}
                  >
                    {state.userAccess?.map((item) => (
                      <MenuItem
                        key={item.additional_access_id}
                        value={item.additional_access_id}
                      >
                        <Checkbox
                          checked={
                            userDetails?.additionalAccess?.indexOf(
                              item.additional_access_id
                            ) > -1
                          }
                        />
                        <ListItemText primary={item.additional_access_en} />
                      </MenuItem>
                    ))}
                  </UpdateSelect>
                </FormControlForSelect>
              </UpdateSelectBox>
            </Grid>
            <Grid item xs={12} md={5.5}>
              <UpdateSelectBox>
                <UpdateSelectTag sx={{ marginTop: "0px" }}>
                  Preferred Language for Emails
                </UpdateSelectTag>
                <UpdateSelect
                  variant="standard"
                  name="language"
                  value={userDetails.language}
                  onChange={handleFormChange}
                  renderValue={handleLanguage}
                  MenuProps={MenuProps}
                >
                  {state.languages?.map((language) => (
                    <MenuItem
                      key={language.preferred_language_type}
                      value={language.preferred_language_type}
                    >
                      <Checkbox
                        checked={
                          userDetails?.language?.indexOf(
                            language.preferred_language_type
                          ) > -1
                        }
                      />
                      <ListItemText
                        primary={language.preferred_language_description}
                      />
                    </MenuItem>
                  ))}
                </UpdateSelect>
              </UpdateSelectBox>
            </Grid>
          </AddDetailsBox>
          <AddButtonBox>
            <AddButton
              variant="contained"
              disabled={!state.isNewUserFormDataChange}
              onClick={handleAddSubmit}
            >
              {state.onNewUserSubmitLoading && state.isNewUserFormDataChange ? (
                <CircularProgress
                  size={20}
                  sx={{ color: "white" }}
                ></CircularProgress>
              ) : (
                "Save Updates"
              )}
            </AddButton>
          </AddButtonBox>
        </AddDetailsContainer>
      </AddUserContainer>
    </Box>
  );
};
